import { XSmall } from '@doist/icons/brand';
import { MetaPill, Text } from '@doist/marketist';
import cn from 'clsx';
import { useTranslation } from 'next-i18next';
import css from './product-ui-comment-field.module.css';
import type { ReactNode } from 'react';
type ProductUICommentFieldIdleProps = {
  variant: 'idle' | 'hovered';
  avatar: ReactNode;
  chips?: never;
  footerSection?: never;
};
type ProductUICommentFieldExpandedProps = {
  variant: 'expanded';
  avatar?: never;
  chips?: ReactNode | ReactNode[];
  footerSection?: ReactNode;
};
type ProductUICommentFieldProps = {
  children: ReactNode;
  variant: 'idle' | 'hovered' | 'expanded';
} & (ProductUICommentFieldIdleProps | ProductUICommentFieldExpandedProps);
function ProductUICommentField({
  variant = 'idle',
  chips,
  avatar,
  footerSection,
  children,
  ...rest
}: ProductUICommentFieldProps) {
  const {
    t
  } = useTranslation('productui');
  if (variant === 'idle' || variant === 'hovered') {
    return <div className={cn(css.container, css[variant])} {...rest}>
                <div className={css.avatar}>{avatar}</div>
                <div className={css.commentField}>{children}</div>
            </div>;
  }
  return <div className={cn(css.expandedContainer, css[variant])} {...rest} data-sentry-component="ProductUICommentField" data-sentry-source-file="product-ui-comment-field.tsx">
            <div className={css.chips}>
                <MetaPill size="small" tag="span" data-sentry-element="MetaPill" data-sentry-source-file="product-ui-comment-field.tsx">
                    {t('notify')}
                </MetaPill>
                {chips}
            </div>
            <div className={css.commentField}>{children}</div>
            {footerSection}
        </div>;
}
type CommentNotifyChipProps = {
  avatar: ReactNode;
  name: string;
};
ProductUICommentField.CommentNotifyChip = function ({
  avatar,
  name
}: CommentNotifyChipProps) {
  return <div className={css.chip}>
            <div className={css.avatar}>{avatar}</div>
            <Text size="body-2xs">{name}</Text>
            <XSmall width={14} height={14} color="var(--display-onlight-tertiary)" />
        </div>;
};
type FooterSectionProps = {
  buttons?: ReactNode[];
  button?: ReactNode;
};
ProductUICommentField.FooterSection = function ({
  buttons,
  button
}: FooterSectionProps) {
  return <div className={css.footerSection}>
            <div className={css.buttons}>{buttons}</div>
            {button}
        </div>;
};
export { ProductUICommentField };